import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { FC } from 'react';
import { Owner } from '../../applications-types';

const OwnersTooltip: FC<React.PropsWithChildren<OwnersTooltipProps>> = ({
  owners,
}) => {
  const { classes } = useStyles();
  return (
    <ul className={classes.ownersTooltip}>
      {owners.map(o => (
        <li key={o.name + o.email} className={classes.listItem}>
          {o.name} ({o.email})
        </li>
      ))}
    </ul>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  ownersTooltip: {
    listStyle: 'inside',
    padding: '0 10px',
  },
  listItem: {
    wordBreak: 'break-all',
  },
}));

export interface OwnersTooltipProps {
  owners: Owner[];
}

export default OwnersTooltip;
